import Overlay from './Overlay/Overlay';
import ZoomImage from './ZoomImage/ZoomImage';
import { ProductSizeInterface } from '../../../../../Interface/ProductSize';
import { useAtomValue } from 'jotai';
import { selectedFlavorFamily } from '../../../../Atoms/ProductAtoms';

type ProductImageProps = {
  product_size: ProductSizeInterface;
  onImageClick?: () => void;
};

const ProductImage = ({ product_size, onImageClick }: ProductImageProps) => {
  const selectedFlavor = useAtomValue(selectedFlavorFamily(product_size.id));
  return (
    <div
      className="position-relative"
      onClick={() => {
        onImageClick?.();
      }}
    >
      <ZoomImage
        src={
          selectedFlavor?.flavorImages?.front_image_url ||
          product_size.image_uri
        }
      />
      {product_size?.is_new ||
      product_size?.image_overlay_uri ||
      (product_size?.single_deposit_price > 0 &&
        product_size?.deposit_units_count > 0) ? (
        <Overlay product_size={product_size} />
      ) : null}
    </div>
  );
};

export default ProductImage;
